<!--维保提醒-->
<template>
  <div style="overflow-x: hidden;overflow-y: auto; height: 100%;">
    <div class="page_header">
      <span class="page_title">{{ $t('maintenanceReminder.维保提醒') }}</span>

      <el-form :inline="true" :model="searchForm" size="small" style="flex:1;text-align: right;">
        <el-form-item :label="$t('maintenanceReminder.车型')">
          <el-input v-model="searchForm.vehicleModel" :placeholder="$t('maintenanceReminder.请输入车型')"
            clearable></el-input>

        </el-form-item>
        <el-form-item :label="$t('maintenanceReminder.阅读状态')">
          <el-select v-model="searchForm.readStatus" :placeholder="$t('maintenanceReminder.请选择阅读状态')">
            <el-option :label="$t('maintenanceReminder.全部')" value="-1"></el-option>
            <el-option :label="$t('maintenanceReminder.已阅')" value="1"></el-option>
            <el-option :label="$t('maintenanceReminder.未阅')" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">{{ $t('public.query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="exportData">{{ $t('public.export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="batchMarkAsRead" :disabled="selectedRows.length === 0">
            {{ $t('maintenanceReminder.批量设置为已读') }}
          </el-button>
        </el-form-item>
      </el-form>


    </div>
    <el-divider></el-divider>

    <!-- 搜索条件 -->
    <div class="search_container">

    </div>

    <!-- 数据表格 -->
    <div class="page_container">
      <el-table :data="tableData" v-loading="loading" stripe style="width: 100%;"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" width="55"></el-table-column>
        <el-table-column prop="CarNo" align="center" :label="$t('maintenanceReminder.车牌号')"
          min-width="120"></el-table-column>
        <el-table-column prop="VehicleModel" align="center" :label="$t('maintenanceReminder.车型')" min-width="100">

        </el-table-column>
        <el-table-column prop="Part" align="center" :label="$t('maintenanceReminder.零部件')"
          min-width="160"></el-table-column>
        <el-table-column prop="Items" align="center" :label="$t('maintenanceReminder.保养说明')" min-width="180">
        </el-table-column>
        <el-table-column prop="IsRead" align="center" :label="$t('maintenanceReminder.阅读状态')" min-width="120">
          <template slot-scope="scope">
            <el-tag :type="scope.row.IsRead === 1 ? 'success' : 'warning'">
              {{ scope.row.IsRead === 1 ? $t('maintenanceReminder.已阅') : $t('maintenanceReminder.未阅') }}
            </el-tag>
          </template>
        </el-table-column>

      </el-table>
      <kl-pagination style="margin-bottom: 10px;" :pageSize="form.PageSize" :total="total" @current-change="pageChange"
        :current-page.sync="form.PageNo" @size-change="sizeChange">
      </kl-pagination>
    </div>


  </div>
</template>

<script>

import { mapState } from 'vuex'
import { maintananceReminder, maintanancePatchRead } from '@/http/vehicle'
export default {
  name: 'MaintenanceReminder',
  components: {

  },
  computed: {
    ...mapState({
      selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
  },
  data() {
    return {
      // 搜索表单
      form: {
        PageNo: 1,
        PageSize: 10
      },
      searchForm: {
        vehicleModel: '',
        readStatus: '0'
      },
      loading: false,
      beginDate: undefined,
      endDate: undefined,
      // 表格数据
      tableData: [],
      total: 0,
      // 选中的行
      selectedRows: []

    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    handleSearch() {
      this.loadData();
    },
    exportData() {
      this.loadData(1);
    },
    getSelectedVehicles() {
      let vehicles = "";
      for (let k = 0; k < this.selectedVehicles.length; k++) {
        if (this.selectedVehicles[k].treeLevel == 5) {
          vehicles = vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return vehicles.substring(0, vehicles.length - 1);
    },
    onExport() {

      //数据导出
      this.loadData(1);
    },
    onQuery(val) {
      this.beginDate = val ? val.beginDate : undefined;
      this.endDate = val ? val.endDate : undefined;
      this.form.PageNo = 1;
      this.loadData();
    },
    resetForm() {
      this.searchForm = {
        vehicleModel: '',
        readStatus: '-1'
      };
      this.form.PageNo = 1;
      this.loadData();
    },
    // 加载数据
    loadData(isExport) {
      isExport = isExport || 0;
      this.loading = true


      maintananceReminder({
         "OperatorID": "7625", "Vehicles": this.getSelectedVehicles(), "VehicleModel": this.searchForm.vehicleModel, "IsExport": isExport, "Language": this.$store.getters.LanguageId, "PageNo": this.form.PageNo, "PageSize": this.form.PageSize,
         "IsRead":parseInt(this.searchForm.readStatus)
        }


        , isExport == 1 ? 'blob' : 'json').then(res => {
          this.loading = false;
          if (isExport == 1) {
            let blob = new Blob([res], {
              type: "application/vnd.ms-excel;charset=utf-8",
            }); // 重点代码

            let a = document.createElement("a");
            a.href = window.URL.createObjectURL(blob);
            a.download = this.$t('maintenanceReminder.维保提醒') + '.xlsx'; // 默认文件名

            a.click(); // 执行下载
            window.URL.revokeObjectURL(blob); // 释放ur
            // window.open(settings.baseUrl + "longyi/xlsx/" + res.data)
          } else {

            this.tableData = res.data || []
            this.total = res.count || 0

          }
        })


    },
    sizeChange(size) {
      this.form.PageSize = size;
      this.loadData();
    },
    // 分页变化
    pageChange(page) {
      this.form.PageNo = page;
      this.loadData();
    },
    // 处理表格选择变化
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    // 批量设置为已读
    batchMarkAsRead() {
      if (this.selectedRows.length === 0) {
        this.$message.warning(this.$t('maintenanceReminder.请选择需要设置为已读的记录'));
        return;
      }

      // 模拟批量设置为已读操作
      this.loading = true;

      maintanancePatchRead({
        RecordIDs: this.selectedRows.map(row => row.RecordID),

      }).then(res => {
        this.loading = false;

        if (res.code == 200) {
          this.selectedRows = [];
          this.$message.success(this.$t('maintenanceReminder.批量设置为已读成功'));
          this.loadData();
        } else {
          this.$message.error(res.msg || this.$t('maintenanceReminder.批量设置为已读失败'));
        }
      })


    },
  }
}
</script>

<style scoped>
.search_container {
  margin-bottom: 20px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}
</style>